import LinensSection from './LinensSection';

export default LinensSection;
